import { Grid } from '@mui/material';
import { useEffect } from 'react';

const LoadingScreen = () => {


  return (
    <Grid
      sx={{
        backgroundColor: 'red',
        minHeight: '100%'
      }}
    />
  );
};

export default LoadingScreen;
